export enum InputMode {
  TEXT = "text",
  DECIMAL = "decimal",
  NUMERIC = "numeric",
  TEL = "tel",
  SEARCH = "search",
  EMAIL = "email",
  URL = "url",
}

export enum NumberSeparator {
  SPACE = " ",
}
